export default __webpack_public_path__ + "70ccd0675303634ec933c82c34b77000.png";